import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { CarCard } from "@perxis-auto/ui-kit/lib/components/CarCard";
const CardPrice = memo(function CardPrice2({ isLoading = false, ...props }) {
  if (isLoading) {
    return /* @__PURE__ */ jsx(CarCard.PriceSkeleton, {});
  }
  return /* @__PURE__ */ jsx(CarCard.Price, { ...props });
});
export {
  CardPrice
};
